<!-- Rejected Assessments -->
<div class="row" [ngClass]="isArabic ? 'arabicAlign' : ''">
    <div class="col-8 asessmentList">
        <form [formGroup]="assessmentForm">
            <label class="ques p-0" [ngClass]="isArabic ? 'rightAlign' : ''">
                <span *ngIf="!isArabic">Please select an Assessment :</span>
                <span *ngIf="isArabic">: يرجى اختيار تقييم</span>
            </label>
            <div class="ans-pnl">
                <select class="form-select" (change)="selectQuestionnaire($event)" formControlName="questionnaire"
                    [ngClass]="isArabic ? 'rightAlign' : ''">
                    <option value=""><span *ngIf="!isArabic">Select Option</span><span *ngIf="isArabic">اختر خياراً</span>
                    </option>
                    <option *ngFor="let eachQuestionnaire of questionnaireList; let i=index;"
                        [value]="eachQuestionnaire.questionnaireId">{{eachQuestionnaire.questionnaireName}}</option>
                </select>
            </div>
        </form>
    </div>
    <div class="col-6">
    </div>
</div>

<!-- <div class="rightComp" *ngIf="rejectedQuestions == undefined || rejectedQuestions == null || rejectedQuestions.length <= 0">
    <p>
        <span *ngIf="!isArabic">Nothing to see here!! You will see items here once they have been rejected by the supervisor.</span>
        <span *ngIf="isArabic">لا شيء تراه هنا !! سترى العناصر هنا بمجرد رفضها من قبل المشرف.</span>
    </p>
</div>
<div class="col-12 rejectedSection" *ngIf="rejectedQuestions && rejectedQuestions.length > 0">
    <label class="rejectedLabel">
        <span *ngIf="!isArabic">List of Rejected Questions :</span>
        <span *ngIf="isArabic">قائمة الأسئلة المرفوضة:</span>
    </label>
    <div *ngFor="let eachQuestion of rejectedQuestions; let i = index" class="mb-3 rejectedQuesDiv">
        <div class="innerDiv">
            <div>
                <label>
                    <span class="quesNo">
                        <span *ngIf="!isArabic">Assessment : </span>
                        <span *ngIf="isArabic">تقييم :</span>
                    </span>
                    <span>{{eachQuestion.questionnaireName}}</span>
                </label>
            </div>
            <div>
                <label>
                    <span class="quesNo">
                        <span *ngIf="!isArabic">Question : </span>
                        <span *ngIf="isArabic">سؤال : </span>
                    </span>
                    <span>{{eachQuestion.quesDesc}}</span>
                </label>
            </div>
            <div>
                <label>
                    <span class="comments">
                        <span *ngIf="!isArabic">Comments : </span>
                        <span *ngIf="isArabic">التعليقات : </span>
                    </span>
                    <span>{{eachQuestion.comments}}</span>
                </label>
            </div>
            <div class="resubmitWithComments">
                <div>
                    <label class="commentHistory" (click)="showCommentsHistory(eachQuestion.commentHistory)">
                        <span *ngIf="!isArabic">Show Comments History</span>
                        <span *ngIf="isArabic">إظهار محفوظات التعليقات</span>
                    </label>
                </div>
                <div class="resubmit">
                    <button type="submit" class="btn btn-primary" (click)="goForQuesSubmission(eachQuestion)">
                        <span *ngIf="!isArabic">Resubmit</span>
                        <span *ngIf="isArabic">إعادة الإرسال</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div> -->